module.exports = __webpack_public_path__ + "HappyCreditoemail.9bf04404.png";